import { render, staticRenderFns } from "./saleerData.vue?vue&type=template&id=2b968934&scoped=true&class=full-height&"
import script from "./saleerData.vue?vue&type=script&lang=js&"
export * from "./saleerData.vue?vue&type=script&lang=js&"
import style0 from "./saleerData.vue?vue&type=style&index=0&lang=css&"
import style1 from "./saleerData.vue?vue&type=style&index=1&id=2b968934&scoped=true&lang=css&"
import style2 from "./saleerData.vue?vue&type=style&index=2&id=2b968934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b968934",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b968934')) {
      api.createRecord('2b968934', component.options)
    } else {
      api.reload('2b968934', component.options)
    }
    module.hot.accept("./saleerData.vue?vue&type=template&id=2b968934&scoped=true&class=full-height&", function () {
      api.rerender('2b968934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/components/saleerData.vue"
export default component.exports